import React from "react";

function EnvMissingView() {
  return (
    <section className="maintenance-view" aria-label="System Maintenance">
      <div className="maintenance-card glass-panel">
        <div className="maintenance-icon-wrapper">
          <svg
            className="maintenance-icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
          </svg>
        </div>
        <h1 className="maintenance-title">System Update</h1>
        <p className="maintenance-message">
          We are currently upgrading our systems to bring you a more immersive music experience. 
          Please check back shortly.
        </p>
        <div className="maintenance-loader">
          <div className="maintenance-pulse"></div>
          <span>Systems will be back online soon</span>
        </div>
      </div>
    </section>
  );
}

export default EnvMissingView;
